import { useCallback } from 'react';

import { ICellRendererParams } from 'ag-grid-community';
import { Checkbox } from 'primereact/checkbox';
import { useTranslation } from 'react-i18next';

import {
  BillableShippedGridContext,
  BillableShippedRow,
} from '../utils/columnDefs';

export const VerifiedCellRenderer = (
  params: ICellRendererParams<BillableShippedRow, boolean>,
) => {
  const { t } = useTranslation();
  const isVerified = params.value ?? false;
  const isReconciled = params.data?.isReconciled ?? false;
  const context = params.context as BillableShippedGridContext;

  const handleChange = useCallback(() => {
    if (!params.data?.fertilizationId) return;
    context.onVerifyToggle(params.data.fertilizationId, isVerified);
  }, [context, params.data?.fertilizationId, isVerified]);

  return (
    <span
      className="flex w-full justify-center"
      title={
        !isReconciled
          ? t('billableShipped.mustReconcileBeforeVerify')
          : undefined
      }
    >
      <Checkbox
        checked={isVerified}
        disabled={!isReconciled && !isVerified}
        onChange={handleChange}
      />
    </span>
  );
};
